import React from 'react';
import { Award, Clock, MapPin, Wrench, Star, Factory, Zap, Handshake } from 'lucide-react';
export function TrustStrip() {
  const trustPoints = [{
    icon: <Award className="w-6 h-6" data-id="element-364" />,
    text: '30+ Years in Business'
  }, {
    icon: <Factory className="w-6 h-6" data-id="element-365" />,
    text: 'In-House Production'
  }, {
    icon: <MapPin className="w-6 h-6" data-id="element-366" />,
    text: 'Nationwide Fulfillment'
  }, {
    icon: <Zap className="w-6 h-6" data-id="element-367" />,
    text: 'Fast, Reliable Turnaround'
  }, {
    icon: <Star className="w-6 h-6" data-id="element-368" />,
    text: 'Why Choose Wear Haus',
    isLink: true
  }, {
    icon: <Handshake className="w-6 h-6" data-id="element-369" />,
    text: 'Contract Manufacturing'
  }];
  return <section className="py-12 bg-gray-50 border-y border-gray-100" data-id="element-370">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-371">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8" data-id="element-372">
          {trustPoints.map((point, index) => <div key={index} className="flex items-center gap-3" data-id="element-373">
              <div className="flex-shrink-0 text-wh-pink" data-id="element-374">{point.icon}</div>
              {point.isLink ? <a href="#about" className="text-sm font-semibold text-gray-700 hover:text-wh-pink transition-colors" data-id="element-375">
                  {point.text}
                </a> : <span className="text-sm font-semibold text-gray-700" data-id="element-376">
                  {point.text}
                </span>}
            </div>)}
        </div>
      </div>
    </section>;
}